import React from "react";
import "./Portrait.css";

function Portrait() {
  return <div className="hover-portrait"></div>;
}

export default Portrait;
